module.exports = __webpack_public_path__ + "static/media/class-placeholder-gray.73b5c33e.svg";